<!-- 
@if (okService.billing.plan.account_type == "Pricing2024") {
  <app-account-pricing2024></app-account-pricing2024>
}
@else {
  <app-account-workerplan></app-account-workerplan>
} -->
<app-account-pricing2024></app-account-pricing2024>